import axios from 'axios';
import * as endpoint from '../../../endpoint';
import {
  checkCancelToken,
  consolelog,
  delCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';
import { REPORT_UPDATE_ERROR_CODE } from '../../../../lib/constants';

/**
 * 報告書のフレームを削除する。
 * TODO: テスト書くこと
 *
 * @param {string} apiToken - APIトークン
 * @param {string} groupId - グループID。このグループに紐づく報告書一覧を削除する。
 * @param {string} reportId - 報告書ID。この報告書に紐づくフレームを削除する。
 * @param {string} frameId - フレームID。このフレームを削除する。
 * @param {string} lastModifiedDate - フレームの最終更新日時。
 * @returns {Function} dispatch - Redux dispatch関数
 */
const deleteReportFrame =
  (apiToken, groupId, reportId, frameId, lastModifiedDate) => dispatch => {
    consolelog('[API CALL] deleteReportFrame()', apiToken);
    configureAxiosForJSON(apiToken);

    // キャンセルトークンの設定
    const { cancelToken, cancelTokenKey } =
      createCancelToken('deleteReportFrame');

    // urlの設定
    const url = endpoint.API_DELETE_REPORT_FRAME.replace('{groupId}', groupId)
      .replace('{reportId}', reportId)
      .replace('{frameId}', frameId);

    // axiosの設定オプション
    const axiosConfig = {
      headers: {
        'If-Unmodified-Since': lastModifiedDate,
      },
      cancelToken,
    };

    return axios
      .delete(url, axiosConfig)
      .then(res => {
        if (checkCancelToken(cancelTokenKey)) {
          dispatch({
            type: 'SUCCESS_API_DELETE_FRAME',
            payload: { frameId, reportUpdatedAt: res.data.reportUpdatedAt },
          });
        }
        return res;
      })
      .catch(thrown => {
        if (!axios.isCancel(thrown)) {
          if (
            thrown?.response?.status !== 400 &&
            thrown?.response?.data?.errorCode !==
              REPORT_UPDATE_ERROR_CODE.UNEDITABLE_CONTENT
          ) {
            handleErrorResponse(
              thrown,
              dispatch,
              '',
              'フレームを削除できませんでした。',
            );
          }
        }
        return thrown;
      })
      .finally(() => {
        delCancelToken(cancelTokenKey);
      });
  };

export default deleteReportFrame;
